
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Product } from '@/types/product';
import { persistConfig } from './persistConfig';

interface FavoritesStore {
  favorites: Product[];
  addFavorite: (product: Product) => void;
  removeFavorite: (productId: string) => void;
  isFavorite: (productId: string) => boolean;
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      favorites: [],
      addFavorite: (product) => 
        set((state) => ({
          favorites: [...state.favorites, product]
        })),
      removeFavorite: (productId) =>
        set((state) => ({
          favorites: state.favorites.filter((item) => item.id !== productId)
        })),
      isFavorite: (productId) => 
        get().favorites.some((item) => item.id === productId),
    }),
    persistConfig('favorites-storage')
  )
);
